import { useState } from 'react'
import { router } from '@inertiajs/react'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetFooter,
} from '@/components/ui/sheet'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Switch } from '@/components/ui/switch'



export type PeopleScope = 'donors' | 'prospects'

interface DonorFilterSheetProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  currentSearch: string | null
  currentQ: Record<string, string> | null
  basePath: string
}

// The status filter is intentionally absent: each sidebar view (Donnateurs /
// Prospects) is a hard partition driven by the route, not the query string.
export function DonorFilterSheet({
  open,
  onOpenChange,
  currentSearch,
  currentQ,
  basePath,
}: DonorFilterSheetProps) {
  const [donorType, setDonorType] = useState<string>(currentQ?.donor_type_eq ?? 'all')
  const [withDiscarded, setWithDiscarded] = useState<boolean>(
    currentQ?.with_discarded === 'true'
  )

  function handleApply() {
    const q: Record<string, string> = {}
    if (donorType && donorType !== 'all') q.donor_type_eq = donorType
    if (withDiscarded) q.with_discarded = 'true'

    const params: Record<string, string | Record<string, string>> = {}
    if (currentSearch) params.search = currentSearch
    if (Object.keys(q).length > 0) params.q = q

    router.get(basePath, params as Record<string, string>, { preserveState: true })
    onOpenChange(false)
  }

  function handleReset() {
    setDonorType('all')
    setWithDiscarded(false)
    router.get(basePath, {}, { preserveState: true })
    onOpenChange(false)
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-[340px] sm:max-w-[340px]">
        <SheetHeader>
          <SheetTitle>Filtres</SheetTitle>
        </SheetHeader>

        <div className="space-y-6 py-6 px-4">
          <div className="space-y-2">
            <Label htmlFor="type-filter">Type</Label>
            <Select value={donorType} onValueChange={setDonorType}>
              <SelectTrigger id="type-filter" className="w-full">
                <SelectValue placeholder="Tous" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tous</SelectItem>
                <SelectItem value="individual">Individuel</SelectItem>
                <SelectItem value="organization">Organisation</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="flex items-center justify-between">
            <Label htmlFor="archived-toggle">Inclure les archives</Label>
            <Switch
              id="archived-toggle"
              checked={withDiscarded}
              onCheckedChange={setWithDiscarded}
            />
          </div>
        </div>

        <SheetFooter className="px-4">
          <Button variant="outline" onClick={handleReset} className="flex-1">
            Reinitialiser
          </Button>
          <Button onClick={handleApply} className="flex-1">
            Appliquer
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  )
}
